import { render, staticRenderFns } from "./MateriaisSort.vue?vue&type=template&id=acded0e0&scoped=true"
import script from "./MateriaisSort.vue?vue&type=script&lang=js"
export * from "./MateriaisSort.vue?vue&type=script&lang=js"
import style0 from "./MateriaisSort.vue?vue&type=style&index=0&id=acded0e0&prod&scoped=true&lang=css"
import style1 from "./MateriaisSort.vue?vue&type=style&index=1&id=acded0e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acded0e0",
  null
  
)

export default component.exports